import React from 'react';
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import {
  FREQUENCY_ONCE,
  FREQUENCY_WEEKLY,
  FREQUENCY_MONTHLY,
  FREQUENCY_EVERY_OTHER_WEEK,
} from '../../../../../models/donationsNew';

const EventFrequencySelector = ({
  frequency,
  disabled,
  onChange,
  disableWeekly = false,
  disableMonthly = false,
  disableEveryOtherWeek = false,
}) => (
  <FormControl variant="standard" data-testid="frequency-selector">
    <FormLabel component="legend">Frequency</FormLabel>
    <RadioGroup name="frequency" value={frequency} row onChange={event => onChange(parseInt(event.target.value, 10))}>
      <FormControlLabel
        data-testid="frequency-once"
        control={
          <Radio color="secondary" disabled={disabled} checked={frequency === FREQUENCY_ONCE} value={FREQUENCY_ONCE} />
        }
        label="One time only"
      />
      <FormControlLabel
        data-testid="frequency-weekly"
        control={
          <Radio
            color="secondary"
            disabled={disabled || disableWeekly}
            checked={frequency === FREQUENCY_WEEKLY}
            value={FREQUENCY_WEEKLY}
          />
        }
        label="Weekly"
      />
      <FormControlLabel
        data-testid="frequency-monthly"
        control={
          <Radio
            color="secondary"
            disabled={disabled || disableMonthly}
            checked={frequency === FREQUENCY_MONTHLY}
            value={FREQUENCY_MONTHLY}
          />
        }
        label="Monthly"
      />
      <FormControlLabel
        data-testid="frequency-every_other_week"
        control={
          <Radio
            color="secondary"
            disabled={disabled || disableEveryOtherWeek}
            checked={frequency === FREQUENCY_EVERY_OTHER_WEEK}
            value={FREQUENCY_EVERY_OTHER_WEEK}
          />
        }
        label="Every other week"
      />
    </RadioGroup>
  </FormControl>
);

export default EventFrequencySelector;
